// firebase config
// AIzaSyAtNJH8d-vt9u0zXZuNJMQtxV52KWRP6Zw



export const firebaseConfig = {
  apiKey: "AIzaSyDhqg3oxpQGP0hoDOBWi05-c8FBInyhz7M",
  authDomain: "digital-planet-hq.firebaseapp.com",
  projectId: "digital-planet-hq",
  storageBucket: "digital-planet-hq.appspot.com",
  messagingSenderId: "486687887736",
  appId: "1:486687887736:web:a3ff87851f20fa9c17b88d",
  measurementId: "G-ZEDWCVBZ2J"
};

